export interface DeckNotificationTooltip {
  element: HTMLDivElement;
  id: string;
  position: number[];
  data: DeckNotificationHistoricalData[];
}

export interface DeckNotificationHistoricalData {
  device: {
    deviceId: string;
    deviceType: string;
  };
  message: string;
  messageTranslation: string;
  ownerName: string;
  notification: {
    category: string;
    notificationReceivedTime: number;
    timeOccurred: number;
    deviceId: string;
    deviceType: string;
    type: string;
  };
}
